import { Dispatch } from 'redux';
import { NoteOption, updateFilters } from './amlFiltersReducer';

export const updateFiltersAction = (selected: NoteOption) => (dispatch: Dispatch) => {
  return dispatch(updateFilters(selected));
};
